<template>
  <div class="body" :style="{backgroundColor: backgroundColor, color:fontColor}">
    <div>
      <div class="top-cell-container">
        <div class="back-btn" @click="onGoback">
          <i class="cubeic-back"></i>
        </div>
        <div class="title-container">{{articleRecord.title}} - {{articleRecord.chapter_id}}</div>
      </div>
      <div class="loading-info" v-if="isLoading">
        <Loading type="spinner"></Loading>
      </div>
      <div v-if="showNeedAuth" class="part-outer-box">
        <div class="article-container">
          <div :key="fontSize" v-html="articleRecord.content" class="content-container-part"
               :style="{fontSize: fontSize + 'px'}"></div>
        </div>
        <div class="chapter-charge">
          <div class="base-info-desc">
            <div class="info-item">本章解锁: <span class="figure"> {{articleRecord.credit}} </span>书币</div>
          </div>

          <div class="exchange-btn-container">
            <cube-button class="button-exchange" @click="onExchangeArticleRecord"
                         :disabled="loadingExchange"
            >解锁本章
            </cube-button>
            <cube-button class="button-exchange" @click="onExchangeNovelPartial" :disabled="loadingExchangeNovelPartial"
                         v-if="showExchangePartial">
              <div class="btn-text-container"> 特惠批量解锁章节
                <icon-svg icon-class="tehui" class="exchange-tehui-icon"></icon-svg>
              </div>
            </cube-button>

            <cube-button class="button-exchange" @click="onExchangeNovel" v-if="showExchangeBook"
                         :disabled="loadingExchangeNovel">
              <div class="btn-text-container"> 特惠购买全本
                <icon-svg icon-class="tehui" class="exchange-tehui-icon"></icon-svg>
              </div>
            </cube-button>
          </div>
        </div>
      </div>

      <div class="article-container" v-else>
        <div :key="fontSize" v-html="articleRecord.content" class="content-container"
             :style="{fontSize: fontSize + 'px'}"></div>
      </div>
      <div>
        <div class="bottom-info-container">
          <div class="next-page-btn-container">
            <cube-button :outline="true" :inline="true" @click="onNextPage" class="next-page-btn">下一章</cube-button>
          </div>
          <div class="bottom-info">
            <div @click="onPrevPage">
              上一章
            </div>
            <div class="option-container">
              <div class="option-item" @click="onClickPanel">
                设置
              </div>
            </div>
            <div class="back-btn-inline" @click="showList">
              <icon-svg icon-class="menu"></icon-svg>
              <div>目录</div>
            </div>
          </div>
        </div>

        <cube-popup v-model="showArticleList" position="left" :mask-closable="true">
          <div class="popup-container">
            <cube-scroll :data="list" v-if="list && list.length > 0">
              <ul class="item-list-wrapper">
                <li class="cell-item" v-for="item in list" @click="onSwitchArticleRecordPage(item)">
                  <div :class="['cell-content-text', '' + item === '' + currentPage?'current-page':'']">第 {{ item }} 章
                  </div>
                </li>
              </ul>
            </cube-scroll>
            <div v-else class="list-loading-container">
              <icon-svg icon-class="loading"></icon-svg>
              <div style="margin-left: 3px;">加载中</div>
            </div>
          </div>
        </cube-popup>

        <cube-popup v-model="showSettingsPanel" position="bottom" class="popup-settings-panel" :mask-closable="true">
          <div class="settings-container">
            <div class="settings-cell">
              <div class="background-color-settings">
                <div class="color-item" v-for="colorItem in colorItemList" @click="onSetBackgroundColor(colorItem)">
                  <div class="item-circle" :style="{backgroundColor: colorItem[0]}"></div>
                </div>
                <div class="color-item" @click="onSetBackgroundColor(['#222', '#848484'])">
                  <icon-svg icon-class="night-on" class="item-circle"></icon-svg>
                </div>
              </div>
              <div class="font-size-settings">
                <div @click="updateFontSize(-1)" class="font-size-icon">
                  <icon-svg icon-class="font_size_down"></icon-svg>
                </div>
                <div @click="updateFontSize(1)" class="font-size-icon">
                  <icon-svg icon-class="font_size_up"></icon-svg>
                </div>
              </div>
            </div>

            <div class="settings-item">
              <div class="settings-item-box" @click="onToHome">
                <icon-svg icon-class="shucheng"></icon-svg>
                <div>书城</div>
              </div>
              <div class="settings-item-box" @click="onComment">
                <icon-svg icon-class="comment-o"></icon-svg>
                <div>{{commentCountDesc}}</div>
              </div>
              <div class="settings-item-box">
                <BookShelfAction :item="novelData"></BookShelfAction>
                <div>{{bookShelfStatusDesc}}</div>
              </div>
            </div>
          </div>
        </cube-popup>
        <DonatePopup v-model="showDonatePopup" :refer="itemId" scene="novel" v-if="itemId"></DonatePopup>
      </div>
    </div>
    <ItemActionStatsEmit :delay="12000" action="view" :itemId="itemId" itemType="novel"
                         :articleRecordId="articleRecord.id" :page="currentPage" :key="currentPage"
                         v-if="currentPage && articleRecord && articleRecord.id && itemId && !isLoading"></ItemActionStatsEmit>
  </div>
</template>

<script>
  import {Loading, Dialog} from "vant"
  import ItemActionStatsEmit from "../../common/ItemActionStatsEmit";
  import DonatePopup from "../../common/DonatePopup";
  import BookShelfAction from "../../common/BookShelfAction";

  export default {
    name: "ArticleRecord",
    components: {
      BookShelfAction,
      DonatePopup,
      ItemActionStatsEmit,
      Loading,
    },
    data() {
      return {
        showDonatePopup: false,
        userId: 0,
        showLoadingComponent: true,
        isLogin: false,

        articleRecord: {},
        totalCount: 0,
        currentPage: 1,
        countPerPage: 0,

        isInBookShelf: false,
        lastReadPage: 0,

        novelData: {},
        recordData: {},
        preloadRecordData: {},
        preloadPageId: 0,

        colorItemList: [["#f8f8f9", "#303741"], ["#d2e4d0", "#303741"], ["#e4e1d8", "#303741"]],
        colorIdMap: {
          "#f8f8f9": "v1",
          "#d2e4d0": "v2",
          "#e4e1d8": "v3",
          "#222": "v4",
        },

        isLoading: true,
        itemId: 0,
        showArticleList: false,
        list: [],
        loadingExchange: false,
        loadingExchangeNovel: false,
        loadingExchangeNovelPartial: false,

        showSettingsFont: false,
        fontSize: 20,

        backgroundColor: "#f8f8f9",
        fontColor: "#303741",

        showSettingsPanel: false,

        favoriteFlag: false,
        refer: "wt_app",

        bannersPage: [],
        bannersPageLock: [],

        listTypeBookShelf: "book_shelf",
      }
    },
    async mounted() {
      this.init()
      await this.initItemInfo()
      this.load()
      this.initUserInfo()
    },

    activated() {
    },

    destroyed() {
      this.initStatusBarColor("white")
    },

    methods: {
      init() {
        this.itemId = this.$route.params.id
        let page = this.$route.query.page
        if (!page) {
          this.currentPage = 1
        } else {
          this.currentPage = parseInt(page)
        }

        let fontSize = this.$store.getters.getFontSize
        if (fontSize) {
          this.fontSize = fontSize
        }

        let pageConfig = this.$store.getters.getPageConfig
        if (pageConfig.background_color) {
          this.backgroundColor = pageConfig.background_color
        }
        if (pageConfig.font_color) {
          this.fontColor = pageConfig.font_color
        }

        this.initStatusBarColor(this.backgroundColor)
      },

      async initItemInfo() {
        await this.loadNovelInfo()
        if (this.lastReadPage && this.currentPage != this.lastReadPage) {
          this.currentPage = this.lastReadPage
        }
      },

      initUserInfo() {
        this.$store.dispatch("CacheAccountInfoMine").then((data) => {
          if (data && data.id) {
            this.userId = data.id
          }
        }, () => {
        })
      },

      async loadNovelInfo() {
        let params = {
          "id": this.itemId,
        }
        await this.$store.dispatch("GetUgcItem", params).then((data) => {
          if (data.code === 0) {
            this.novelData = data.data
            if (this.novelData && this.novelData.item_list && this.novelData.item_list.book_shelf) {
              this.isInBookShelf = true
            } else {
              this.isInBookShelf = false
            }

            if (this.novelData && this.novelData.last_read_page) {
              this.lastReadPage = this.novelData.last_read_page
            }
          } else {
          }
        }, (err) => {
        })
      },

      showList() {
        this.showArticleList = true
        this.onLoadArticleRecordList()
      },

      async load() {
        this.backTop()
        if (this.preloadRecordData && this.preloadRecordData.data && this.preloadPageId === this.currentPage) {
          this.recordData = this.preloadRecordData
        } else {
          this.isLoading = true
          await this.loadRecordData()
          this.isLoading = false
        }

        if (this.recordData && this.recordData.code === 0) {
          let data = this.recordData
          this.articleRecord = data.data
          let extra = data.extra
          this.totalCount = extra.total_count
          this.countPerPage = extra.count_per_page
        }
        this.preloadRecordData = {}
        this.preloadPageId = 0
        this.preloadData()

        this.emitItemViewAction(this.currentPage)
      },

      async loadRecordData() {
        this.itemId = this.$route.params.id
        let params = {
          "item_id": this.itemId,
          "page": this.currentPage,
        }
        await this.$store.dispatch("GetArticleRecordByPage", params).then((data) => {
          if (data.code === 0) {
            this.recordData = data
          } else {
            if (data.code === 10014) {
              this.currentPage = 1
            }
            this.createToast("请求参数错误", "error")
          }
        }, (err) => {
          console.log(err)
        }).catch(() => {
          this.createToast("网络错误", "error")
        })
      },

      preloadData() {
        this.itemId = this.$route.params.id
        let params = {
          "item_id": this.itemId,
          "page": this.currentPage + 1,
        }
        this.$store.dispatch("GetArticleRecordByPage", params).then((data) => {
          if (data.code === 0) {
            this.preloadRecordData = data
            this.preloadPageId = this.currentPage + 1
          }
        }, () => {
        }).catch(() => {
        })
      },

      onChange() {
        if (!this.userId) {
          this.$router.push("/login")
          return
        }

        this.load()
      },

      onNextPage() {
        if (this.currentPage >= this.totalCount) {
          this.createToast("已到结尾", "text")
          return
        }
        this.currentPage += 1
        this.onChange()
      },

      onPrevPage() {
        if (this.currentPage <= 1) {
          this.createToast("已到开头", "text")
          return
        }

        this.currentPage -= 1
        this.onChange()
      },

      onSwitchArticleRecordPage(pageId) {
        this.currentPage = parseInt(pageId)
        this.onChange()
        this.showArticleList = false
      },

      onToHome() {
        this.$router.push("/")
      },

      onGoback() {
        this.$router.go(-1)
      },

      onAddToShelf() {
        let params = {
          item_id: this.itemId,
          action: "add",
          list_type: this.listTypeBookShelf,
        }
        this.$store.dispatch("UpdateItemList", params).then((data) => {
          if (data.code === 0) {
            this.createToast("加入书架", "text")
          } else if (data.code === 20010) {
            this.createToast("登录信息错误", "error")
          } else {
            this.createToast("系统错误", "error")
          }
        }, () => {
          this.createToast("网络异常", "error")
        })
        this.showSettingsPanel = false
      },

      backTop() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },

      createToast(text, type) {
        const toast = this.$createToast({
          time: 1500,
          txt: text,
          type: type,
        })
        toast.show()
      },

      initStatusBarColor(colorBackground) {
        try {
          if (window.injectedObject && window.injectedObject.updateStausBarColor) {
            let colorId = this.colorIdMap[colorBackground]
            if (colorId) {
              window.injectedObject.updateStausBarColor(colorId)
            } else {
              window.injectedObject.updateStausBarColor("white")
            }
          }
        } catch (e) {
          console.log(e)
        }
      },

      async doExchange(itemId, itemType, page) {
        let params = {
          item_id: '' + itemId,
          item_type: itemType,
        };

        if (page) {
          params.page = parseInt(page)
        }
        this.loadingExchange = true
        await this.$store.dispatch("ExchangeCredit", params).then((data) => {
          if (data.code === 0) {
            this.load()
          } else if (data.code === 20010) {
            this.$router.push("/login")
          } else if (data.code === 30001) {
            this.showDonatePopup = true
          } else {
            this.createToast("系统错误", "error")
          }
        }, () => {
          this.createToast("网络错误", "error")
        })
        this.loadingExchange = false
      },

      onExchangeArticleRecord() {
        this.doExchange(this.articleRecord.id, "article_record")
      },

      async onExchangeNovel() {
        let params = {
          "item_id": this.itemId
        }
        this.loadingExchangeNovel = true
        await this.$store.dispatch("GetNovelCredit", params).then((data) => {
          if (data.code === 0) {
            let creditCount = data.data.credit
            let articleRecordCount = data.data.article_record_count
            let creditCountPrev = data.data.credit_prev
            let isNew = data.data.is_new_user_promote
            let title = isNew ? '新人特惠' : ''

            Dialog.confirm({
              title: title,
              message: `${creditCount} 书币解锁剩余 ${articleRecordCount} 章内容
(原价${creditCountPrev}书币)`,
              confirmButtonColor: "#fc9153",
            }).then(() => {
              this.doExchange(this.itemId, "novel")
            }).catch(() => {
            });
          } else if (data.code === 20010) {
            this.$router.push("/login")
          }
        })
        this.loadingExchangeNovel = false
      },

      async onExchangeNovelPartial() {
        let params = {
          "item_id": this.itemId,
          "page": parseInt(this.currentPage),
        }
        this.loadingExchangeNovelPartial = true
        await this.$store.dispatch("GetNovelCredit", params).then((data) => {
          if (data.code === 0) {
            let creditCount = data.data.credit
            let articleRecordCount = data.data.article_record_count
            let creditCountPrev = data.data.credit_prev
            let isNew = data.data.is_new_user_promote
            let title = isNew ? '新人特惠' : ''

            Dialog.confirm({
              title: title,
              message: `${creditCount} 书币解锁此后 ${articleRecordCount} 章内容
(原价${creditCountPrev}书币)`,
              confirmButtonColor: "#fc9153",
            }).then(() => {
              this.doExchange(this.itemId, "novel", this.currentPage)
            }).catch(() => {
            });
          } else if (data.code === 20010) {
            this.$router.push("/login")
          }
        })
        this.loadingExchangeNovelPartial = false
      },



      async onLoadArticleRecordList() {
        if (!this.novelData || !this.novelData.id) {
          await this.loadNovelInfo()
        }

        if (this.novelData && this.novelData.id) {
          let totalCount = this.novelData.article_record_count
          let l = []
          for (let i = 1; i <= totalCount; i++) {
            l.push(i)
          }
          this.list = l
        }
      },

      updateFontSize(delta) {
        if ((this.fontSize <= 9 && delta < 0) || (this.fontSize + delta >= 28 && delta > 0)) {
          return
        }
        this.fontSize += delta
        this.$store.dispatch("SetFontSize", this.fontSize)
      },

      onSetBackgroundColor(c) {
        this.backgroundColor = c[0]
        this.fontColor = c[1]

        this.$store.dispatch("SetPageConfig", {
          "background_color": this.backgroundColor,
          "font_color": this.fontColor,
        })

        this.initStatusBarColor(this.backgroundColor)
      },

      onClickPanel() {
        this.showSettingsPanel = true
      },

      onComment() {
        this.$router.push("/comment/" + this.itemId)
      },

      emitItemViewAction(page) {
        let params = {
          "item_id": parseInt(this.itemId),
          "page": page,
          "refer": this.refer,
          "action": "view",
        }
        this.$store.dispatch("DoItemAction", params).then(() => {
        }, () => {
        })
      }
    },
    computed: {
      showNeedAuth() {
        if (this.articleRecord && this.articleRecord.id > 0 && !this.articleRecord.is_auth) {
          return true
        } else {
          return false
        }
      },

      commentCountDesc() {
        if (this.novelData && this.novelData.comment_count) {
          return this.novelData.comment_count
        } else {
          return "书评"
        }
      },

      bookShelfIcon() {
        if (this.isInBookShelf) {
          return "done"
        } else {
          return "add-bookshelf"
        }
      },

      bookShelfStatusDesc() {
        if (this.isInBookShelf) {
          return "已加入书架"
        } else {
          return "加入书架"
        }
      },


      showExchangePartial() {
        if (this.articleRecord && this.articleRecord.id > 0 && this.articleRecord.show_exchange_partial) {
          return true
        } else {
          return false
        }
      },

      showExchangeBook() {
        if (this.articleRecord && this.articleRecord.id > 0 && this.articleRecord.show_exchange_full) {
          return true
        } else {
          return false
        }
      },
    }
  }
</script>

<style lang="scss" scoped>

  .body {
    /*background: #e4e1d8;*/
    min-height: 100vh;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }

  .title-container {
    padding: 12px 8px;
    font-size: 14px;
    color: rgba(103, 103, 103, 0.58);
  }

  .top-cell-container {
    color: rgba(103, 103, 103, 0.58);
    display: flex;
    align-items: center;
  }

  .back-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    height: 44px;
    padding: 0 15px;
  }

  .article-container {
    margin: 0 20px;
    position: relative;
    min-height: 25vh;

    .content-container {
      min-height: 70vh;
      line-height: 1.6;
      letter-spacing: 1px;

      ::v-deep p {
        padding: 6px 0;
        margin: 6px 0;
      }
    }

    .content-container-part {
      line-height: 1.6;
      letter-spacing: 1px;

      ::v-deep p {
        padding: 6px 0;
        margin: 6px 0;
      }

      height: 10vh;
      overflow: hidden;
    }
  }

  .loading-info {
    position: absolute;
    width: 100%;
    height: 40vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;
  }

  .loading-spinner {
    position: fixed;
    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  .bottom-info-container {
    color: #666;
    padding: 22px 18px;
    font-size: 16px;

    .next-page-btn-container {
      display: flex;
      align-items: center;
      justify-content: center;

      .next-page-btn {
        font-size: 18px;
        padding: 12px 0;
        width: 100%;
      }
    }

    .bottom-info {
      margin-top: 18px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .back-btn-inline {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .option-container {
        font-size: 16px;
        color: rgba(128, 128, 128, 0.91);

        .option-item {

        }
      }
    }
  }


  .popup-container {
    background: white;
    width: 150px;
    height: 100vh;

    .list-loading-container {
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      display: flex;
    }
  }

  .cell-item {
    margin: 15px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .cell-content-text {
      padding: 4px 0;
      text-align: center;
    }

    .current-page {
      color: red;
      font-weight: bold;
    }
  }

  .popup-settings-panel {
    .settings-container {
      background: #f0f0f2;
    }

    .settings-cell {
      display: flex;
      align-items: center;
      justify-content: space-around;
      border-bottom: 1px solid #e4e4e4;
    }

    .font-size-settings {
      color: #585e66;
      font-size: 16px;
      display: flex;
      align-items: center;
      padding: 8px 15px;

      .font-size-icon {
        margin: 0 4px;
        border: 1px solid #585e66;
        padding: 3px 8px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
      }
    }

    .background-color-settings {
      display: flex;
      align-items: center;

      .color-item {
        margin: 0 5px;

        .item-circle {
          width: 25px;
          height: 25px;
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          border-radius: 50%;
        }
      }
    }

    .settings-item {
      color: #454545;
      padding: 15px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .settings-item-box {
        min-height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-direction: column;
      }
    }
  }


  .banner-container {
    img {
      width: 100%;
    }
  }

  .qr-info {
    padding: 0 24px;
  }


  .chapter-charge {
    margin: 0 15px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    font-size: 12px;
    background: white;
    color: #585e66;
    padding: 8px 10%;
    /*padding: .4rem 0;*/
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);

    .base-info-desc {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 0;
      border-bottom: 1px solid #f2f2f2;
      font-size: 16px;

      .figure {
        font-weight: bold;
      }
    }

    .exchange-btn-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 0;
      flex-direction: column;

      .btn-text-container {
        position: relative;
      }

      .exchange-tehui-icon {
        position: absolute;
        right: 0;
        top: -5px;
        font-size: 26px;
      }

      .button-exchange {
        color: rgba(75, 75, 75, 0.89);
        background: rgba(213, 214, 209, 0.33);
        min-width: 75%;
        margin-top: 15px;
      }
    }
  }
</style>
